<p-dialog [visible]="visible" (visibleChange)="visibleChange.emit($event)" [modal]="true"
    [header]="'commercialContextEdit.title' | transloco" [draggable]="false" [resizable]="false"
    [style]="{ width: 'min(980px, 94vw)' }" [breakpoints]="{ '860px': '96vw' }"
    styleClass="commercial-context-dialog">
    <section class="commercial-dialog-body">
        <aside class="commercial-dialog-summary">
            <div class="summary-icon"><i class="pi pi-file-edit"></i></div>
            <div>
                <small>{{ 'commercialContextEdit.eyebrow' | transloco }}</small>
                <h3>{{ documentNumber }}</h3>
                <p>{{ 'commercialContextEdit.summary' | transloco }}</p>
            </div>
            <div class="summary-facts">
                <div><span>{{ 'commercialContextEdit.client' | transloco }}</span><strong>{{ partyName || '—' }}</strong></div>
                <div><span>{{ 'commercialContextEdit.issuedPdf' | transloco }}</span><strong>{{ 'commercialContextEdit.unchanged' | transloco }}</strong></div>
            </div>
        </aside>
        <div class="commercial-dialog-form">
            @if (error) { <small class="save-error" role="alert">{{ error.startsWith('commercialContextEdit.') ? (error | transloco) : error }}</small> }
            <p-inputGroup class="wide-field">
                <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <input id="commercialReference" pInputText [ngModel]="externalReference" (ngModelChange)="externalReferenceChange.emit($event)" maxlength="150" />
                    <label for="commercialReference">{{ 'commercialContextEdit.externalReference' | transloco }}</label>
                </p-iftalabel>
            </p-inputGroup>
            <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <input id="commercialDueDate" pInputText type="date" [ngModel]="dueDate" (ngModelChange)="dueDateChange.emit($event)" />
                    <label for="commercialDueDate">{{ 'commercialContextEdit.dueDate' | transloco }}</label>
                </p-iftalabel>
            </p-inputGroup>
            <p-inputGroup>
                <p-inputGroupAddon><i class="pi pi-briefcase"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <app-logistics-project-lookup inputId="commercialProject" [companyId]="companyId"
                        [ngModel]="projectId" (ngModelChange)="projectIdChange.emit($event)"
                        [placeholder]="'commercialContextEdit.selectProject' | transloco"></app-logistics-project-lookup>
                    <label for="commercialProject">{{ 'commercialContextEdit.logisticsProject' | transloco }}</label>
                </p-iftalabel>
            </p-inputGroup>
            <p-inputGroup class="wide-field">
                <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <p-select inputId="commercialContact" [options]="contacts" optionLabel="name" optionValue="id"
                        [ngModel]="contactId" (ngModelChange)="contactIdChange.emit($event)" [filter]="true"
                        filterBy="name,email,phone" [showClear]="true" [loading]="contactsLoading"
                        [disabled]="!crmClientId || contactsLoading" appendTo="body" styleClass="w-full"
                        [placeholder]="'commercialContextEdit.selectContact' | transloco">
                        <ng-template let-contact pTemplate="item">{{ contact.name || contact.email || contact.phone || contact.mobile || '—' }}</ng-template>
                        <ng-template let-contact pTemplate="selectedItem">{{ contact.name || contact.email || contact.phone || contact.mobile || '—' }}</ng-template>
                    </p-select>
                    <label for="commercialContact">{{ 'commercialContextEdit.crmContact' | transloco }}</label>
                </p-iftalabel>
            </p-inputGroup>
            @if (!crmClientId) { <small class="field-hint wide-field">{{ 'commercialContextEdit.noClient' | transloco }}</small> }
            <div class="line-comments wide-field">
                <h4>{{ 'commercialContextEdit.lineComments' | transloco }}</h4>
                @for (line of lineComments; track line.lineId) {
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-align-left"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <textarea pTextarea [id]="'commercialLine' + line.lineId" rows="2" [(ngModel)]="line.comment"></textarea>
                            <label [for]="'commercialLine' + line.lineId">{{ line.description }}</label>
                        </p-iftalabel>
                    </p-inputGroup>
                }
            </div>
        </div>
    </section>
    <ng-template pTemplate="footer">
        <div class="commercial-dialog-footer">
            <small>{{ 'commercialContextEdit.footerNote' | transloco }}</small>
            <span class="footer-spacer"></span>
            <p-button [label]="'commercialContextEdit.cancel' | transloco" severity="secondary" [outlined]="true"
                [disabled]="saving" (click)="visibleChange.emit(false)"></p-button>
            <p-button [label]="'commercialContextEdit.save' | transloco" icon="pi pi-save"
                [loading]="saving" [disabled]="saving || contactsLoading" (click)="save.emit()"></p-button>
        </div>
    </ng-template>
</p-dialog>
